<template>
  <section v-if="hasDates" class="dates">
    <img class="icon" src="@/assets/images/calendar-blue.svg" />
    <template v-if="isSameMonth">
      <search-summary-bar-details-calendar-same-month :date-range="dates" />
    </template>
    <template v-else>
      <i18n-t keypath="{fromDate} - {toDate}">
        <template #fromDate>
          <pu-utc-date :date="dates.arrive" options="dayMonth" />
        </template>
        <template #toDate>
          <pu-utc-date :date="dates.depart" options="dayMonth" />
        </template>
      </i18n-t>
    </template>
  </section>

  <div v-else class="title">
    <img
      class="icon"
      src="@/assets/images/calendar-blue.svg"
      width="21"
      height="21"
      alt=""
    />
    <translate>Choose your dates</translate>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { ArriveDepartIso } from '../../../apps/search/types'

@Component
class DatesWizardSummaryDesktop extends Vue {
  @Prop({ required: false })
  dates: ArriveDepartIso

  get hasDates() {
    return this.dates && this.dates.arrive && this.dates.depart
  }

  get isSameMonth() {
    const arrive = new Date(this.dates.arrive)
    const depart = new Date(this.dates.depart)
    return arrive.getMonth() === depart.getMonth()
  }
}

export default toNative(DatesWizardSummaryDesktop)
</script>
<style scoped>
.title {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: var(--colour-dark-blue);
  font-weight: 500;
}

.dates {
  font-weight: bold;
  color: var(--colour-dark-blue);
}

.icon {
  height: 1.3em;
  margin-right: 0.35em;
  width: auto;
}

svg {
  width: 1em;
  height: auto;
}
</style>
